<template>
    <div>
    <div style="display: flex;flex-wrap: wrap;" class="mb-5">
        <div>
        <label>Thématique</label>
        <vs-input class="mr-5 mb-5" v-model="thisThema.name"></vs-input>
        </div>

        <div class="mr-5 mb-5">
        <label>Plateforme Média Référent %</label>
        <vs-input type="number" v-model="thisThema.pmr"></vs-input>
        </div>
        <div class="mr-5 mb-5">
        <label>Plateforme Article Sponsorisé %</label>
        <vs-input type="number" v-model="thisThema.pas"></vs-input>
        </div>
        <div class="mr-5 mb-5">
        <label>Plateforme Lien HP %</label>
        <vs-input type="number" v-model="thisThema.plh"></vs-input>
        </div>
        <div class="mr-5 mb-5">
        <label>Régie Article Sponsorisé %</label>
        <vs-input type="number" v-model="thisThema.ras"></vs-input>
        </div>
        <div class="mr-5 mb-5">
        <label>Régie Média Référent
 %</label>
        <vs-input type="number" v-model="thisThema.rmr"></vs-input>
        </div>
        <div class="mr-5 mb-5">
        <label>Éditeur Média Référent %</label>
        <vs-input type="number" v-model="thisThema.emr"></vs-input>
        </div>
        <div class="mr-5 mb-5">
        <label>Éditeur Article Sponsorisé %</label>
        <vs-input type="number" v-model="thisThema.eas"></vs-input>
        </div>
    </div>
    <vs-button
    @click="saveThema(thisThema)">Enregistrer</vs-button>
</div>
  </template>

<script>
import request from "@/axios.js";
import store from "@/store/store";
export default {
	name: "NetlinkThemaPopup",
	props: {
		isPopupActive: Boolean,
		isEdit: Boolean,
		thematique: Object

	},
	data() {
		return {
			apiUrl: this.$store.state.backendApiUrl,
			thisThema: this.$props.isEdit?
				this.$props.thematique:
				{
					name: null,
					level: null,
					pmr: null,
					pas: null,
					plh: null,
					ras: null,
					rmr: null,
					emr: null,
					eas: null
				}
		};
	},
	created(){
		//console.log("THIS THEMATIQUE ", this.$props.thematique);
		this.thisThema = this.$props.isEdit? this.$props.thematique: {name: "", level: 0};
	},
	computed: {
		netlinkThemaList: () => {
			return store.state.netlinkThemas;
		}
	},
	watch: {
		"$props.thematique": function(data){
			this.thisThema = data;
		}
	},
	methods: {
		saveThema(thema){
			if(this.$props.isEdit) this.editThema(thema);
			else this.newThema(thema);
		},
		async editThema(thisThema){
			try{
				await request.post("/netlink/thema/edit", thisThema);
				this.$vs.notify({
					title: "Succès",
					text: "Thématique modifié avec succès."
				});
				this.$emit("close-thema-popup", "");
				store.dispatch("getAllNetlinkThemaList");

			}
			catch(err){
				this.$vs.notify({
					title: "Echec",
					text: "Error " + err.toString()
				});
			}
		},
		async newThema(thisThema){
			try{
				await request.post("/netlink/thema/new", thisThema);
				this.$vs.notify({
					title: "Succès",
					text: "Thématique ajouté avec succès."
				});
				this.$emit("close-thema-popup", "");
				store.dispatch("getAllNetlinkThemaList");

			}
			catch(err){
				this.$vs.notify({
					title: "Echec",
					text: "Error " + err.toString()
				});
			}
		}
	}
	// Your component's properties and methods here
};
</script>

